<template>
  <q-btn
    @click="updatePoints"
    @keydown.space="updatePoints"
    :color="activePoints === points ? activeColor : 'grey-5'"
    :text-color="activePoints === points ? 'white' : 'grey-8'"
    :label="points"
    round
    size="md"
  />
</template>
<script>
export default {
  name: 'selectable-points',
  model: {
    prop: 'activePoints',
    event: 'onUpdatePoints',
  },
  props: {
    points: {
      type: [String, Number],
      required: true,
    },
    activePoints: {
      type: [String, Number],
      required: true,
    },
    activeColor: {
      type: String,
      required: true,
    },
  },
  methods: {
    updatePoints() {
      this.$emit('onUpdatePoints', this.points);
    },
  },
};
</script>
<style lang="scss">
.text-ellipsis {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  & > p {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
